export type UUIDVersion = "v1" | "v3" | "v4" | "v5" | "v6" | "v7";

export interface UUIDGeneratorState {
  uuidVersion: UUIDVersion;
  quantity: number;
  namespace: string;
  name: string;
  generatedUUIDs: string[];
  copiedIndex: number | null;
}

export const INITIAL_STATE: UUIDGeneratorState = {
  uuidVersion: "v4",
  quantity: 1,
  namespace: "6ba7b810-9dad-11d1-80b4-00c04fd430c8",
  name: "",
  generatedUUIDs: [],
  copiedIndex: null,
};
